import * as jsonLogic from '../../lib/json-logic-utils';

export const MAX_ROWS = 10000;
export const MAX_SHEETS = 220;
export const DEFAULT_SHEETS = 50;

export function calculateAlerts(template, row) {
  const variables = jsonLogic.getVariables(row.answers, [...template.questions, ...template.contextQuestions]);
  return template.alerts.filter(alert => jsonLogic.evaluate(JSON.parse(alert.expression), variables));
}